import { render } from "./Header.vue?vue&type=template&id=99158418&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=99158418&scoped=true&lang=css"

import exportComponent from "/Users/macbook/Desktop/SILA/Web/phone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99158418"]])

export default __exports__